import instance from '@/api/api'
//单文件上传OSS服务器
export const uploadUserProFile  = params =>{
  return instance.post('/upload/ossFile', params);
}
//多文件上传OSS服务器
export const uploadUserProFiles  = params =>{
  return instance.post('/upload/ossFiles', params);
}
//更新头像
export const updateUserProFile = params =>{
  return instance.post('/user/updateUserInfo',params);
}
//获取头像信息
export const getUserProfile = () =>{
  return instance.post('/user/getAvatars');
}
//获取用户信息
export const getUserInfo = () =>{
  return instance.post('/user/getUserInfo');
}
// 不登录根据userId获取用户信息
export const getUserInfoByUserId = params =>{
  return instance.get('/common/getUserInfoByUserId?' + params);
}
//获取附件信息
export const getUserAppendix = params =>{
  return instance.post('/user/getUserAppendixInfo?'+ params);
}
//逻辑删除附件接口
export const deleteAppendix = params =>{
  return instance.post('/user/delUserFile?'+params);
}
//获取附件属性描述
export const getAppendixConfig = () =>{
  return instance.get('/user/getUserAppendixConfigList');
}
//更新附件信息
export const updateAppendixInfo = params =>{
  return instance.post('/user/uploadUserFile',params);
}
//改变附件公开状态
export const changeAppendixAuth = params =>{
  return instance.post('/user/changeAppendixPublicStatus?'+params);
}
//保存提供商信息
export const updateMerchantInfo = params =>{
  return instance.post('/merchant/saveMerchantInfo',params);
}
//提供商信息提交
export const auditMerchantInfo = () =>{
  return instance.post('/merchant/applicationReview');
}
//获取站内消息
export const getNettyMessage = params =>{
  return instance.post('/netty/getHistoryMessage',params);
}
//标记站内信已读
export const updateMessageIsRead = params =>{
  return instance.post('/netty/markedRead',params);
}
//删除站内信
export const deleteMessage = params =>{
  return instance.post('/netty/delMessage',params);
}




// WEBPACK FOOTER //
// ./src/api/userInfo/userInfo.js